import { Component, OnInit } from '@angular/core';
import { Market, MarketsInput } from '../../api/models/market-model';
import { MarketService } from '../../api/services/market.service';
import { AuthService } from '../../api/services/auth.service';
import { UserService } from '../../api/services/user.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { MarketBannerService } from '../market-banner/market-banner.service';
import { Router } from '@angular/router';
import { PaginatedRequest } from '../../api/models/paginated-request';
import { HeaderService } from '../header/header.service';

@Component({
  selector: 'app-dashboard-markets',
  templateUrl: './dashboard-markets.component.html',
  styleUrls: ['./dashboard-markets.component.scss']
})
export class DashboardMarketsComponent implements OnInit {

  items: Market[] = [];
  page = 1;
  pageSize = 50;
  currentMarket: string;
  isTesscoUser = false;
  loading: boolean;
  paginatedRequest: PaginatedRequest;
  totalRecords = 0;
  sorting: string = 'customerName,name';
  searchTextValue: string;
  highlightSearchButton: boolean = false;
  marketsInput: MarketsInput;
  infoMsg = ['No records found!'];

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private marketService: MarketService,
    private preferencesService: PreferencesService,
    private marketBannerService: MarketBannerService,
    private router: Router,
    private headerService: HeaderService
  )  {
  }

  setLoading(value: boolean) {
    this.loading = value;
  }

  searchAllMarkets(value){
    if(!value){
      this.highlightSearchButton = false;
      this.searchTextValue = "";
      this.loadPage(1);
    } else {
      this.highlightSearchButton = true;
    }
  }

  loadPage(page) {
    this.setLoading(true);
    this.marketsInput = new MarketsInput();
    this.marketsInput.marketIds = this.userService.getMarketPermittedForCurrentUser();
    this.marketsInput.searchTerm = this.searchTextValue;
    this.paginatedRequest = new PaginatedRequest(page, this.pageSize, this.sorting);
    this.marketService.getMarketsListMinimalInfo(this.paginatedRequest, this.marketsInput).subscribe(paginatedResponse => {
      this.setLoading(false);
      this.items = paginatedResponse.records;
      this.totalRecords = paginatedResponse.totalRecords;
    }, error => {
      this.setLoading(false);
      this.items = [];
      this.totalRecords = 0;
    });
  }

  setCurrentMarket(id: string) {
    this.preferencesService.setPreference('USER', this.authService.getUserId(), 'current-market', {Value: id})
    .subscribe(() => {
      this.marketBannerService.refreshMarketBanner();
      this.currentMarket = id;
      let mySubscription = this.marketBannerService.getMarketBanner().subscribe(market => {
        if(market){
          this.preferencesService.getPreferences('CUSTOMER', market.customerId).subscribe(prefs => {
            mySubscription.unsubscribe();
            if (prefs['special-fields'].Value === 'Verizon eQuote' || prefs['special-fields'].Value === 'Standard'){
              this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['market-order-summary', this.currentMarket] } }]);
            }else{
              this.router.navigate(['dashboard']);
            }
          });
          this.headerService.marketSelectedBool.next(true);
        }else{
          // Market not found
        }
      }, error => {
        // Error while fetching Market banners
      });
    });
  }

  ngOnInit() {
    this.searchTextValue = "";
    this.loadPage(1);

    this.preferencesService.getPreferences('USER', this.authService.getUserId()).subscribe(prefs => {
      if (prefs && prefs['current-market']) {
        this.currentMarket = prefs['current-market'].Value;
      }
    });

    this.userService.findUserById(this.authService.getUserId())
    .switchMap(user => this.authService.getUserRolesInContext(`ORGANIZATION~${user['Organization ID']}`))
    .subscribe(roles => {
      if (roles.includes('TESSCO')) {
        this.isTesscoUser = true;
      }
    });
  }

  searchMarket(value) {
    this.page = 1;
    if (value && value.trim().length > 0) {
      this.searchTextValue = value.trim();
    } else {
      this.searchTextValue = "";
    }
    this.loadPage(this.page);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-markets/dashboard-markets.component.ts